<tour-step-template>
    <ng-template let-step="step" class="custom-tour-container">
        <mat-card [style.width]="step.stepDimensions?.width" [style.min-width]="step.stepDimensions?.minWidth"
            [style.max-width]="step.stepDimensions?.maxWidth">
            <mat-card-header>
                <div class="header-group">
                    <span class="header-title"> {{ step.title | camelCase }}</span>
                    <button mat-icon-button (click)="tourService.end()" class="close customBtn">
                        <mat-icon>close</mat-icon>
                    </button>
                </div>
            </mat-card-header>
 
            <mat-card-content class="mat-body tour-body" [innerHTML]="step.content | camelCase"></mat-card-content>

            <mat-card-actions class="tour-actions" [class.no-progress]="!step.showProgress">
                
                @if (step.showProgress) {
                    <div class="custom-progress">{{ tourService.steps.indexOf(step) + 1 }} / {{ tourService.steps.length }}</div>
                }
                <div class="nav-actions">
                    @if(tourService.hasPrev(step)){
                    <button mat-button class="prev customBtn" (click)="tourService.prev()">
                        {{ step.prevBtnTitle | camelCase}}
                    </button>
                    }
                    @if (tourService.hasNext(step) && !step.nextOnAnchorClick) {
                    <button class="next customBtn" (click)="tourService.next()" mat-button>
                        {{ step.nextBtnTitle  | camelCase}}
                    </button>
                    }
                    @if (!tourService.hasNext(step)) {
                    <button class="customBtn" mat-button (click)="tourService.end()">
                        {{ step.endBtnTitle | camelCase }}
                    </button>
                    }
                </div>
                

            </mat-card-actions>
        </mat-card>
    </ng-template>
</tour-step-template>